import changeActiveSurface from '../actions/changeActiveSurface';
import updateActiveSurface from '../mutators/updateActiveSurface';
import ActiveSurfaceView from '../store/schema/ActiveSurfaceView';
import getSurfaceStore from '../store/store';
import { resetAgendaStore } from 'mini-calendar-agenda-store';
import { lazyResetDayViewStore } from 'mini-calendar-dayview-store';
import { orchestrator } from 'satcheljs';

/**
 * Orchestrates the cleanup of current active view store, and mutates the new value.
 */
export default orchestrator(changeActiveSurface, async ({ newSurface }) => {
    const { activeSurfaceView } = getSurfaceStore();
    if (newSurface !== activeSurfaceView) {
        switch (activeSurfaceView) {
            case ActiveSurfaceView.AGENDA:
                resetAgendaStore();
                break;
            case ActiveSurfaceView.DAY:
                lazyResetDayViewStore.importAndExecute();
                break;
        }
        updateActiveSurface({ newSurface: newSurface });
    }
});
